<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Edit City</h1>

            <!-- <span class="mainDescription"
              >Use this page to start from scratch and put your custom
              content</span
            > -->
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-cities' }">Back</router-link>
          </div>
          <!-- <ol class="breadcrumb">
            <li class="active">
              <span>Blank Page</span>
            </li>
          </ol> -->
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <form class="text-start mx-auto" @submit.prevent="editCity">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="text-">English Name</label>
                    <input type="text" class="form-control" placeholder="Enter English Name" v-model="name_en"
                      required />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="cityName">Arabic Name</label>
                    <input type="text" class="form-control" placeholder="Enter Arabic Name" v-model="name_ar"
                      required />
                  </div>
                </div>
                <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label for="cityName">Postal Code</label>
                    <input type="text" class="form-control" placeholder="Enter Postal Code" v-model="postal_code" />
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="cityName">Shipping Price</label>
                  <input type="number" class="form-control" placeholder="Enter Shipping Price" v-model="shipping_price"
                    required />
                </div> -->
                <!-- <div class="form-group">
                  <label for="countrySelect">Select Country</label>
                  <select class="form-select" v-model="country_id" aria-label="Select country">
                    <option v-for="(country, index) in countries" :key="index" :value="country.id">
                      {{ country.name }}
                    </option>
                  </select>
                </div> -->

              </div>
              <button class="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
export default {
  name: "EditCity",
  data() {
    return {
      name_en: "",
      name_ar: "",
      // postal_code: "",
      // shipping_price: "",
      // country_id: null,
      // countries: [],
    };
  },
  created() {
    this.fetchCity();
  },

  methods: {

    async fetchCity() {
      try {
        const response = await axios.get(
          "/admin/admin/city/get/" + this.$route.params.id
        );
        const cityData = response.data.data;
        console.log(cityData);
        this.name_en = response.data.data.name_en;
        this.name_ar = response.data.data.name_ar;

      } catch (error) {
        console.error(error);
      }
    },
    async editCity() {
      try {
        const formData = new FormData();
        formData.append("id", this.$route.params.id);
        formData.append('name_en', this.name_en);
        formData.append('name_ar', this.name_ar);

        const response = await axios.post(
          "/admin/admin/city/update", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        console.log(formData)
        console.log(response.data);
        this.$router.push({ name: "all-cities" });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
form {
  padding: 1rem;
  border: 1px solid #ccc;
  background-color: white;
  /* Add a background color */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Add a shadow for better visibility */
  width: 100%;
  /* max-width: 500px; Optional: Max width for better responsiveness */
}

form>.form-group {
  margin-bottom: 1.5rem;
}

button {
  width: 100%;
}
</style>
